import PropTypes from "prop-types";
import styles from "./TabBar.module.css";
import classNames from "classnames";

/**
 * Interactive component used to change what page is being displayed.
 */

export function TabBar({ titleList, onChange, activeTitle, isNewSubmitted }) {
  return (
    <div className={styles.container}>
      {titleList.map((title, index) => {
        return (
          <div
            key={index}
            onClick={() => onChange(title.title)}
            className={classNames(
              activeTitle === title.title ? styles.selected : styles.tab,
              index === 0
                ? styles.tab1
                : index === titleList.length - 1
                ? styles.tab3
                : styles.tab2
            )}
          >
            {title.notification > 0 && (
              <span className={styles.circle}>{title.notification}</span>
            )}

            {title.title}
            {isNewSubmitted > 0 && title.title === "Submitted Agenda Items" && (
              <div className={styles.newSubmittedIcon}>{isNewSubmitted}</div>
            )}
          </div>
        );
      })}
    </div>
  );
}

TabBar.propTypes = {
  titleList: PropTypes.array.isRequired, // Array of strings for tab names and notifications
  onChange: PropTypes.func, // Changes what Tab is selected
  activeTitle: PropTypes.string, // Tab selected
};
